import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './material.module';

import { AppConfigService } from '@libs/providers/app-config.service';
import { AuthModule } from '@libs/utils/src/lib/auth';
import { CoreModule } from './core.module';

import '@omnitracs/web-navigation-components';
import '@omnitracs/footer-component';

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		HttpClientModule,
		MaterialModule,
		CoreModule,
 		AuthModule,
		//comment above line to work locally
	],
	providers: [
		{
			provide: APP_INITIALIZER,
			multi: true,
			deps: [AppConfigService],
			useFactory: (appConfigSvc: AppConfigService) => {
				return () => {
					return appConfigSvc.loadConfig()
				};
			}
		}
	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
